module.exports = __webpack_public_path__ + "img/cart.70f5ed64.svg";